import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue-demi';
import { AbSlider, AbSliderItem, AbSection } from '../../ui';
import useGsap from '../../../composables/useGsap';
import { type CategoryBannerData } from '../../../types';
import { CategoryBannerLarge } from '../';
import { Spacing } from '../../../helpers/shared-props';

interface Props {
  items: CategoryBannerData[];
  variant?: 'light';
  spacing?: Spacing;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionCarouselButton',
  props: {
    items: { default: () => [
    {
      title: 'Default title',
      description: 'Default description',
      color: 'gray',
      image: '/img/power-banks.png',
      alt: '',
    },
  ] },
    variant: null,
    spacing: null
  },
  setup(__props: any) {



const swiperContainer = ref();
const progress = ref('0%');
const duration = 0.8;
const ease = 'power1.out';
const rotation = 0;
const space = 50;
const { gsap } = useGsap();

const animateStart = () => {
  if (!swiperContainer.value) return;
  if (!swiperContainer.value.$el) return;
  if (gsap) {
    const swiperSlideActiveImage =
      swiperContainer.value.$el.shadowRoot?.querySelector(
        '.swiper-slide-active .image'
      );
    const swiperSlideActiveImageBox =
      swiperContainer.value.$el.shadowRoot?.querySelector(
        '.swiper-slide-active .image-box'
      );
    if (swiperSlideActiveImage)
      gsap.fromTo(
        swiperSlideActiveImage,
        { y: space, rotation, duration, ease, opacity: 0 },
        {
          y: 0,
          rotation: 0,
          duration,
          ease,
          opacity: 1,
        }
      );
    if (swiperSlideActiveImageBox)
      gsap.fromTo(
        swiperSlideActiveImageBox,
        { y: -space, duration, opacity: 0 },
        {
          y: 0,
          duration,
          opacity: 1,
        }
      );
  }
};

const animateEnd = () => {
  if (!swiperContainer.value) return;
  if (!swiperContainer.value.$el) return;
  if (gsap) {
    const swiperSlideNextImage =
      swiperContainer.value.$el.shadowRoot?.querySelector(
        '.swiper-slide-next .image'
      );
    const swiperSlideNextImageBox =
      swiperContainer.value.$el.shadowRoot?.querySelector(
        '.swiper-slide-next .image-box'
      );
    const swiperSlidePrevImage =
      swiperContainer.value.$el.shadowRoot?.querySelector(
        '.swiper-slide-prev .image'
      );
    const swiperSlidePrevImageBox =
      swiperContainer.value.$el.shadowRoot?.querySelector(
        '.swiper-slide-prev .image-box'
      );
    if (swiperSlideNextImageBox)
      gsap.fromTo(
        swiperSlideNextImageBox,
        { y: 0, duration, opacity: 1 },
        {
          y: -space,
          duration,
          opacity: 0,
        }
      );
    if (swiperSlidePrevImageBox)
      gsap.fromTo(
        swiperSlidePrevImageBox,
        { y: 0, duration, opacity: 1 },
        {
          y: -space,
          duration,
          opacity: 0,
        }
      );
    if (swiperSlideNextImage)
      gsap.fromTo(
        swiperSlideNextImage,
        { y: 0, rotation: 0, duration, ease, opacity: 1 },
        {
          y: space,
          rotation: -rotation,
          duration,
          ease,
          opacity: 0,
        }
      );
    if (swiperSlidePrevImage)
      gsap.fromTo(
        swiperSlidePrevImage,
        { y: 0, rotation: 0, duration, ease, opacity: 1 },
        {
          y: space,
          rotation: -rotation,
          duration,
          ease,
          opacity: 0,
        }
      );
  }
};

onMounted(() => {
  animateEnd();
});

const swiperOptions = {
  speed: duration * 1000,
  effect: 'fade',
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  pagination: {
    enabled: true,
    clickable: true,
  },

  on: {
    activeIndexChange: () => {
      swiperContainer.value?.$el.shadowRoot
        .querySelectorAll('.swiper-pagination-bullet')
        .forEach((el: HTMLElement) => {
          el.style.background =
            'var(--swiper-pagination-bullet-inactive-color)';
        });
    },
    autoplayTimeLeft: (_: any, __: any, percentage: number) => {
      progress.value = `${100 - percentage * 100}%`;
    },

    slideChangeTransitionEnd: () => {
      animateEnd();
    },
    slideChangeTransitionStart: () => {
      animateEnd();
      animateStart();
    },
  },
};
watch(progress, (newValue) => {
  if (!swiperContainer.value) return;

  const bulletActive = swiperContainer.value?.$el.shadowRoot.querySelector(
    '.swiper-pagination-bullet-active'
  );

  if (!bulletActive) return;
  bulletActive.style.background = `linear-gradient(90deg, var(--swiper-pagination-color) ${newValue}, var(--swiper-pagination-bullet-inactive-color) 0%)`;
});

return { __sfc: true,swiperContainer, progress, duration, ease, rotation, space, gsap, animateStart, animateEnd, swiperOptions, AbSlider, AbSliderItem, AbSection, CategoryBannerLarge }
}

})